import React from 'react';
import PropTypes from 'prop-types';
import { ContentHeaderData, HeaderItems } from '../styles';

const propTypes = {
  left: PropTypes.node,
  right: PropTypes.node,
  background: PropTypes.string
};

function ActionBarData({ left, right, background }) {
  return (
    <ContentHeaderData background={background || 'colorWhite'}>
      {left && <HeaderItems>{left}</HeaderItems>}
      {right && <HeaderItems rightAligned>{right}</HeaderItems>}
    </ContentHeaderData>
  );
}

ActionBarData.propTypes = propTypes;

export default ActionBarData;



// WEBPACK FOOTER //
// src/modules/theme/theme1/layout/components/ActionBarData.js